import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { UiComponentLibraryModule } from '../_component-library/component-library.module'
import { SharedModule } from '../_shared/shared.module'
import { AboutComponent } from './about/about.component'
import { HomeComponent } from './home.component'
import { HomeRoutingModule } from './home.routing'
import { HomeStartComponent } from './views/start/start.component'
import { HomeView2Component } from './views/view2/view2.component'

@NgModule({
  declarations: [HomeComponent, HomeStartComponent, HomeView2Component, AboutComponent],
  imports: [CommonModule, SharedModule, HomeRoutingModule, UiComponentLibraryModule, FormsModule, ReactiveFormsModule],
  exports: [],
  providers: [],
})
export class HomeModule {}
